import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RadioSharedComponent } from './radio.component';

@NgModule({
    declarations: [
        RadioSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        RadioSharedComponent
    ]
})

export class RadioSharedModule {}
